import { jsonMember, jsonObject } from 'typedjson';
import { PublicCartId } from '../../types/public-cart-id';

@jsonObject
export class PublicCartCreateResponse {
  @jsonMember(String)
  public readonly id!: PublicCartId;
}
